import { Component, Input, inject } from '@angular/core';
import { customCard } from 'src/app/shared/model/customCard';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-climate-partner',
  templateUrl: './climate-partner.component.html',
  styleUrl: './climate-partner.component.scss',
  standalone: false,
})
export class ClimatePartnerComponent {
  @Input() cardslist!: customCard[];

  private translocoService = inject(TranslocoService);

  cardsList: customCard[] = [
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.logos'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.brandKit'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.textTemplate'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.socialMediaDesigns'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.partnerBanner'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.stickers'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.partnershipAgreement'),
      link: 'home/ressources',
    },
    {
      icon: '/assets/icons/blue-folder-bg.svg',
      title: this.translocoService.translate('ressources.customCommunication'),
      link: 'home/ressources',
    },
  ];
}
